import _ from 'lodash';

import { core } from '@tock/coretypes';
import ImportantDateEditorRow, { DateUpdate } from 'components/profile/ImportantDateEditorRow';

interface Props {
  dayValues: core.IPatronProfileDay[];
  onChange(days: core.IPatronProfileDay[]): void;
}

const ImportantDateEditor = ({ dayValues, onChange }: Props) => {
  const typeMap = _.keyBy(dayValues, 'type');
  const handleChangeDate = (type: core.PatronProfile.DayType, update: DateUpdate) => {
    let updatedTypeMap: Dictionary<core.IPatronProfileDay>;
    if (update === 'delete') {
      updatedTypeMap = {
        ...typeMap,
      };
      delete updatedTypeMap[type];
    } else {
      updatedTypeMap = {
        ...typeMap,
        [type]: {
          type,
          day: update.day,
          month: update.month,
        },
      };
    }
    onChange(_.values(updatedTypeMap));
  };
  const dayTypes: core.PatronProfile.DayType[] = ['BIRTHDAY', 'PARTNER_BIRTHDAY', 'ANNIVERSARY'];
  return (
    <div>
      {dayTypes.map((dayType) => {
        const day = typeMap[dayType];
        return (
          <ImportantDateEditorRow
            key={dayType}
            type={dayType}
            month={day?.month || undefined}
            day={day?.day || undefined}
            onChangeDate={handleChangeDate}
          />
        );
      })}
    </div>
  );
};

export default ImportantDateEditor;
